export function removeLeadingSlash(s: string) {
  return s.replace(/^\/+/, '')
}

export function removeTrailingSlash(s: string) {
  return s.replace(/\/+$/, '')
}
